import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Translate, I18n } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb, Input } from 'react-bootstrap';
import Spinner from '../Widgets/spinner';
import axios from 'axios';

import { APP_COLORS, BACKGROUND_COLOR, UI_HEIGHT } from '../../components/Common/constants';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import checkPermission from '../Common/permissions';
import FilterByStart from '../Common/filterByStart';
import FilterMultiKeyword from '../Common/filterMultiKeyword';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle, isUSPride } from '../../actions/root_url';
import { productUpload } from '../../actions/products_actions';
import { PRODUCTS_URL } from '../../actions/url';

const isMyuMyu = ROOT_API_URL === 'https://mmstage-scm.truckxi.com/api/' || ROOT_API_URL === 'https://myumyu-scm.truckxi.com/api/';
const isAFG = ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || ROOT_URL === 'https://afg-scm.truckxi.com/api/';
const isWecom = ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/' || ROOT_API_URL === 'https://wecom-scm.truckxi.com/api/';
const isTN =
  ROOT_API_URL === "https://tn-scm.truckxi.com/api/" ||
  ROOT_URL === "https://tn-scm.truckxi.com/api/";
  const isWIZ = ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
const isSW = ROOT_API_URL === 'https://snapwise-scm.truckxi.com/api/' || ROOT_URL === 'https://snapwise-scm.truckxi.com/api/';
const isABCFF = ROOT_API_URL === 'https://abcff-scm.truckxi.com/api/' || ROOT_URL === 'https://abcff-scm.truckxi.com/api/';
const isSY = ROOT_API_URL === "https://admin.apoodr.com/api/";
const isJML = ROOT_API_URL === "https://jml-scm.truckxi.com/api/";
const isFBD = ROOT_API_URL === 'https://fbd-scm.truckxi.com/api/' || ROOT_URL === 'https://fbd-scm.truckxi.com/api/';
const isLO = ROOT_API_URL === 'https://lonni-scm.truckxi.com/api/' || ROOT_URL === 'https://lonni-scm.truckxi.com/api/';

class RowRenderer extends Component {
  getRowStyle() {
    return {
      color: this.getRowBackground(),
    };
  }

  getRowBackground() {
    if (isAFG){ 
      if (this.props.row.IsStopSale === 'yes') {
        return BACKGROUND_COLOR.red;
      } else if (this.props.row.IsMobile !== 'yes' && this.props.row.IsStopSale !== 'yes') {
        return '#BFA600';
      } else {
        return 'black';
      }
    } else {
      return this.props.row.IsStopSale === 'yes' ? BACKGROUND_COLOR.red : 'black';
    }
  }

  render() {
    // here we are just changing the style
    // but we could replace this with anything we liked, cards, images, etc
    // usually though it will just be a matter of wrapping a div, and then calling back through to the grid
    return (
      <div
        style={this.getRowStyle()}
        onDoubleClick={() => { this.props.onDoubleClick(this.props.row); }}
      >
        <ReactDataGrid.Row ref="row" {...this.props} />
      </div>
    );
  }
}

RowRenderer.PropTypes = {
  onDoubleClick: React.PropTypes.func,
};

class Products extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

      // React Data Grid states
      rows: [],
      selectedRows: [],
      filters: {},
      sortColumn: null,
      sortDirection: null,
      currentGroup: null,
      currentCategory: -1,
      groupExpanded: false,
      clear: true,
      files: null,
      selectedRowsIdx: null,
      quickEntryProductNum: '',
      quickEntryShowError: false,
    };

    this.handleResize = this.handleResize.bind(this);
    this.checkDetail = this.checkDetail.bind(this);
  }

  componentWillMount() {
    this.props.resetGroupAndCategory();
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    window.addEventListener('resize', this.handleResize);
    this.props.fetchGroups();
    let currentCategoryGroup = this.props.currentCategoryGroup;
    if (currentCategoryGroup && currentCategoryGroup.currentGroup) {
      if (currentCategoryGroup.currentGroup != -1) {
        this.props.fetchGroupCategories(currentCategoryGroup.currentGroup);
      }
      let selectedRows = currentCategoryGroup.selectedRows;
      this.setState({
        currentGroup: currentCategoryGroup.currentGroup,
        currentCategory: currentCategoryGroup.currentCategory,
        groupExpanded: true,
        // rows: currentCategoryGroup.currentRows,
        selectedRows,
        selectedRowsIdx: currentCategoryGroup.selectedRowsIdx,
      });
    }

    // if(currentCategoryGroup && currentCategoryGroup.filters) {
    //   console.log("filters", currentCategoryGroup.filters)
    //   this.setState({filters: currentCategoryGroup.filters})
    // }
    // this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
    if (isUSPride && this.props.filters !== this.state.filters) {
      this.setState({ filters: this.props.filters });
      if (Object.keys(this.props.filters).length > 0) {
        this.tableGrid && this.tableGrid.onToggleFilter();
      }
    }
  }

  // Once products are ready, reset state.
  componentWillReceiveProps(nextProps) {
    if (nextProps.product && nextProps.product !== this.props.product) {
      let index = _.findIndex(this.state.rows, { Product_id: nextProps.product });
      this.state.rows.map(r => r.isSelected = false);
      if (index > -1) {
        this.state.rows[index].isSelected = true;
        this.setState({ selectedRows: [this.state.rows[index]] });
      } else {
        this.setState({ selectedRows: [] });
      }
    }
    if (nextProps.groups && nextProps.groups.length !== 0 && nextProps.groups !== this.props.groups && !isSY) {
      let productGroup_id = nextProps.groups[0].ProductGroup_id;
      if (this.state.currentCategory && this.state.currentCategory !== -1) {
        this.props.fetchProductsByCategory(this.state.currentCategory);
        // this.handleClickCategory(this.state.currentCategory);
      } else if (this.state.currentGroup) {
        this.props.fetchProductsByGroup(this.state.currentGroup);
      } else {
        this.props.fetchProductsByGroup(productGroup_id);
        this.setState({ currentGroup: productGroup_id });
      }
    }
    if (nextProps.products && (nextProps.products !== this.props.products)) {
      let products = nextProps.products;
      if (this.props.currentCategoryGroup) {
        if(this.state.selectedRows.length) {
          const selectedRows = this.state.selectedRows;
          const selectedRowProductNumber = selectedRows[0].row.ProductNum;
          let selectedRowIdx;
          let rows = nextProps.products.map((product, idx )=> {
            if(product.ProductNum === selectedRowProductNumber) {
              selectedRowIdx = idx;
              return {
                ...product,
                IsStopSale: product.IsStopSale ? 'yes' : 'no',
                IsMobile: product.IsMobile ? 'yes' : 'no',
                isSelected: true,
              }
            }
            return {
              ...product,
              IsStopSale: product.IsStopSale ? 'yes' : 'no',
              IsMobile: product.IsMobile ? 'yes' : 'no',
            }
          });
          this.setState({ rows, selectedRows });        
          // this.props.setGroupCategory(null);
          setTimeout(() => {
            if (this.tableGrid) {
              var top = 25 * selectedRowIdx;
              var gridCanvas = this.tableGrid.getDataGridDOMNode().querySelector('.react-grid-Canvas');
              gridCanvas.scrollTop = top;
            }
          }, 100);
        }else {
          let rows = nextProps.products.map((product, idx )=> {
            return {
              ...product,
              IsStopSale: product.IsStopSale ? 'yes' : 'no',
              IsMobile: product.IsMobile ? 'yes' : 'no',
            }
          });
          this.setState({ rows, selectedRows: [] });     
        }
      } else {
        let rows = nextProps.products.map(product => ({
          ...product,
          IsStopSale: product.IsStopSale ? 'yes' : 'no',
          IsMobile: product.IsMobile ? 'yes' : 'no',
        }));
        this.setState({ rows, selectedRows: [] });
        this.props.setGroupCategory(null);
      }
    }
    if (isUSPride && nextProps.filters && (nextProps.filters !== this.props.filters)) {
      this.setState({ filters: nextProps.filters });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let productGroup_id = this.state.currentGroup;
    let productCategory_id = this.state.currentCategory;
    let groups = document.getElementsByName('group');
    let i = 0;
    for (; i < groups.length; i++) {
      if (groups[i].id != 'g'+productGroup_id){
        groups[i].style.backgroundColor = null;
      } else {
        groups[i].style.backgroundColor = APP_COLORS['active-category-background-nav'];
      }
    }
    let categories = document.getElementsByName('category');
    i = 0;
    if (categories) {
      for (; i < categories.length; i++) {
        if (categories[i].id != 'c'+productCategory_id){
          categories[i].style.backgroundColor = null;
        } else {
          categories[i].style.backgroundColor = APP_COLORS['active-category-background-nav'];
        }
      }
    }
  }

  componentWillUnmount() {
    if (this.state.clear) { this.props.setGroupCategory(null); }
    this.props.setOriginPage('products');
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize(e) {
    this.setState({tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton});
  }

  // Quick Entry Product Number
  onChangeQuickEntry(e) {
    this.setState({ quickEntryProductNum: e.target.value });
  }

  onKeyPressQuickEntry(e) {
    const handleSuccess = (response) => {
      if (checkPermission('change_product')) {
        const resData0 = response.data[0];
        let newRowsItem = {
          ...resData0,
          isSelected: true,
          IsStopSale: resData0.IsStopSale ? 'yes' : 'no',
          IsMobile: resData0.IsMobile ? 'yes' : 'no',
        };
        if (this.state.currentGroup !== -1) {
          this.state.currentGroup = resData0.ProductGroup_id || -1;
        }
        const newRows = [...this.state.rows];
        newRows.map((r) => {
          r.isSelected = false;
        });
        const idx = newRows.findIndex(item => item.Product_id === newRowsItem.Product_id);
        if (idx > -1) {
          newRowsItem = newRows[idx];
          newRowsItem.isSelected = true;
        }
        const selectedRows = [{
          row: newRowsItem,
          rowIdx: idx,
        }];
        this.setState({ rows: newRows, selectedRows, selectedRowsIdx: idx });
        this.checkDetail(newRowsItem);
      } else {
        alert(I18n.t('msg_no_permission'));
      }
    };
    const handleFailure = (error) => {
      this.setState({ quickEntryShowError: true });
    };
    if (e.charCode === 13) {
      this.props.fetchQuickAccess(this.state.quickEntryProductNum, handleSuccess, handleFailure);
    }
  }

  // Set product being selected to be currentProduct and navigate user to the edit page
  setCurrentProduct(e) {
    e.preventDefault();
    this.setState({ clear: false });
    const currentProduct = this.state.selectedRows[0].row || this.state.selectedRows[0];
    let currentRows = Data.Selectors.getRows(this.state);
    this.props.resetCurrentProduct();
    this.props.selectProduct(currentProduct);
    this.props.setGroupCategory({
      currentGroup: this.state.currentGroup,
      currentCategory: this.state.currentCategory,
      currentProduct_id: currentProduct.Product_id,
      filters: this.state.filters,
      currentRows,
      selectedRowsIdx: this.state.selectedRowsIdx,
      selectedRows: this.state.selectedRows,
    });
    this.context.router.push('/products/' + currentProduct.Product_id);
  }

  checkDetail(data) {
    this.setState({ clear: false });
    const currentProduct = arguments[0];
    let currentRows = Data.Selectors.getRows(this.state);
    this.props.resetCurrentProduct();
    this.props.selectProduct(currentProduct);
    this.props.setGroupCategory({
      currentGroup: this.state.currentGroup,
      currentCategory: this.state.currentCategory,
      currentProduct_id: currentProduct.Product_id,
      filters: this.state.filters,
      currentRows,
      selectedRowsIdx: this.state.selectedRowsIdx,
      selectedRows: [{row: data}],
    });
    this.context.router.push('/products/' + currentProduct.Product_id);
  }

  clickNew = (e) => {
    this.props.setGroupCategory({
      currentGroup: this.state.currentGroup,
      currentCategory: this.state.currentCategory,
      filters: this.state.filters,
      selectedRows: [],
    });
    e.preventDefault();
    this.setState({ clear: false });
    this.props.resetCurrentProduct();
    // this.props.setGroupCategory(null);
    this.context.router.push('/products/new');
  }

  handleClickCategory(id) {
    this.setState({ currentCategory: id });
    this.props.fetchProductsByCategory(id);
  }

  renderCategories(group_id) {
    if (!this.props.groupCategories) return;
    let groupCategories = this.props.groupCategories;
    let description;
    if (localStorage.getItem('lang') === 'ch') {
      description = 'Description';
    } else if (localStorage.getItem('lang') === 'en') {
      description = 'Name';
    }
    if (this.state.currentGroup === group_id && this.state.groupExpanded) {
      return groupCategories.map(category => {
        return (
          <li className="clickListLi" style={{ color: APP_COLORS['sub-category-nav'], fontFamily: 'Arial' }} name="category" id={'c'+category.ProductCategory_id} onClick = {this.handleClickCategory.bind(this, category.ProductCategory_id)}>
            <label style={{ fontWeight: 'bold' }}>{category.CategoryNum}</label>{" " + category[description]}
          </li>
        );
      })
    }
    return;
  }

  handleClickGroup(group, id) {
    let groupExpanded = this.state.groupExpanded;
    // for(; i < groups.length; i++) {
    //   if(groups[i].id != id){
    //     groups[i].style.color = APP_COLORS["category-nav"];
    //   }
    //   else {
    //     groups[i].style.color = APP_COLORS["active-category-nav"];
    //   }
    // }
    if (group && this.state.currentGroup === group.ProductGroup_id) {
      this.setState({ groupExpanded: !groupExpanded });
      if (!groupExpanded || isJML) {
        this.setState({ currentCategory: -1 });
        this.props.fetchProductsByGroup(group.ProductGroup_id);
        this.props.fetchGroupCategories(group.ProductGroup_id);
      }
    } else if (group) {
      this.setState({ currentGroup: group.ProductGroup_id, groupExpanded: true, currentCategory: -1 });
      this.props.fetchProductsByGroup(group.ProductGroup_id);
      this.props.fetchGroupCategories(group.ProductGroup_id);
    } else {
      this.setState({ currentGroup: -1, currentCategory: -1 });
      this.props.fetchProductsByGroup(-1);
    }
  }

  renderGroups() {
    if (!this.props.groups) return;
    let groups = this.props.groups;

    let syGroups = [];
    let syPermissionString = "";
    if (isSY) {
      groups.map(g => {
        syPermissionString = "view_group_" + g.GroupNum;
        if (checkPermission(syPermissionString) || checkPermission("view_group_all")) {
          syGroups.push(g);
        }
      });
      groups = syGroups;
    }

    return groups.map(group => {
      let GroupNum = parseInt(group.GroupNum);
      if (GroupNum < 10) GroupNum = '0' + GroupNum;
      let description;
      if (localStorage.getItem('lang') === 'ch') {
        description = 'Description';
      } else if (localStorage.getItem('lang') === 'en') {
        description = 'Name';
      }
      return (
        <Panel className="panelStyle" >
          <div style={{ color: APP_COLORS['category-nav'], fontFamily: 'Arial Black', cursor: 'pointer' }} name="group" id={'g'+group.ProductGroup_id} onClick = {this.handleClickGroup.bind(this, group, 'g'+group.ProductGroup_id)}>
            <label style={{ fontWeight: 'bold' }}>{GroupNum}</label> {' '}<Translate value={group[description]} />
          </div>
          {this.renderCategories(group.ProductGroup_id)}
        </Panel>
      );
    })
  }

  onDrop(files) {
    this.props.attachDocument(files);
    this.setState({ files });
  }

  renderTable() {
    // if (this.props.isLoading && !this.props.error) {
    //   return <Spinner />
    // } else if (this.props.error) {
    //   return (
    //     <ContentWrapper>
    //       <div id="product-error-wrapper">
    //         <div className="alert alert-danger">{JSON.stringify(this.props.error)}</div>
    //       </div>
    //     </ContentWrapper>
    //   );
    // }

    // Parameters of the react-data-grid
    let tableHeight = (window.innerHeight < 930) ? 680 : 739;

    const getRows = () => Data.Selectors.getRows(this.state);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state, { sortColumn, sortDirection });
      // var state = { ...this.state, sortColumn, sortDirection };
      this.setState(state);
    };

    const handleFilterChange = (filter) => {
      let newFilters = Object.assign({}, this.state.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      if (isUSPride && !filter.rawValue) {
        delete newFilters[filter.column.key];
      }
      if (isUSPride) {
        this.props.setRowsFilters(newFilters);
      } else {
        this.setState({
          filters: newFilters,
        });
      }
      this.setState({
        rows: this.props.products.map(product => ({
          ...product,
          IsStopSale: product.IsStopSale ? 'yes' : 'no',
          IsMobile: product.IsMobile ? 'yes' : 'no',
        })),
      });
    };

    const onClearFilters = () => {
      // all filters removed
      if (isUSPride) {
        this.props.setRowsFilters({});
      } else {
        this.setState({
          filters: {},
        });
      }
      this.setState({
        rows: this.props.products.map(product => ({
          ...product,
          IsStopSale: product.IsStopSale ? 'yes' : 'no',
          IsMobile: product.IsMobile ? 'yes' : 'no',
        })),
      });
    };

    const getValidFilterValues = (columnKey) => {
      const { filters } = this.state;
      return filters[columnKey] ? filters[columnKey].rawValue : '';
    };

    // Handle the row select function

    const onRowSelect = (rows) => {
      this.setState({ selectedRows: rows });
    };

    const onRowsSelected = (rows) => {
      let newRows = [...this.state.rows];
      let selectedRows = this.state.selectedRows;

      newRows.map((r) => {
        r.isSelected = false;
      });

      selectedRows = [];
      rows.map((row) => {
        let index = _.findIndex(this.state.rows, { 'ProductNum': row.row.ProductNum })
        newRows[index].isSelected = true;
        selectedRows.push(row);
      });

      this.setState({ rows: newRows, selectedRows, selectedRowsIdx: rows[0].rowIdx });
    };

    const onRowsDeselected = (rows) => {
      let newRows = [...this.state.rows];
      rows.map((row) => {
        let index = _.findIndex(this.state.rows, { 'ProductNum': row.row.ProductNum })
        newRows[index].isSelected = false;
      });
      let selectedRows = [];
      newRows.map((r) => {
        if (r.isSelected) { selectedRows.push(r); }
      })
      this.setState({ rows: newRows, selectedRows });
    };

    // Custom Formatter component
    const NameFormatter = React.createClass({
      render() {
        if (this.props.value) return <span>{this.props.value.Name}</span>;
        return <span className="label label-danger">-</span>;
      },
    });

    // Discontinued Product Background Color Formatter
    const DiscontinuedProductCellBackGroundFormatter = (props) => {
      const rowBackground = props.dependentValues.IsDiscontinued
        ? BACKGROUND_COLOR.lightGray
        : '';
      return (
        <div style={{ backgroundColor: rowBackground }}>
          <span>{ props.value }</span>
        </div>
      );
    };

    // formatter for IsStopSale
    const IsStopSaleFormatter = React.createClass({
      render() {
        if (this.props.value === 'no') return <span className="label label-success"><Translate value="no" /></span>;
        return <span className="label label-danger"><Translate value="yes" /></span>;
      },
    });

    // Column difinition
    let columns = [
      ...(!isLO) ? [{
        key: 'ProductNum',
        name: <Translate value="prod_num" />,
        resizable: true,
        sortable: true,
        width: 70,
        filterable: true,
        filterRenderer: FilterByStart,
        formatter: DiscontinuedProductCellBackGroundFormatter,
        getRowMetaData: row => row,
      }] : [],
      ...(!isLO) ? [{
        key: 'GeneralNum',
        name: <Translate value={(isMyuMyu || isAFG) ? 'index_no' : 'general_no'} />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        filterRenderer: FilterByStart,
        formatter: DiscontinuedProductCellBackGroundFormatter,
        getRowMetaData: row => row,
      }] : [],
      {
        key: 'RefNum',
        name: (isTN || isWIZ) ? <Translate value="sku" /> : <Translate value="ref_num" />,
        resizable: true,
        sortable: true,
        width: isLO ? 160 : 80,
        filterable: true,
        filterRenderer: FilterMultiKeyword,
        formatter: DiscontinuedProductCellBackGroundFormatter,
        getRowMetaData: row => row,
      },
      {
        key: 'Name',
        name: <Translate value="item_name" />,
        resizable: true,
        sortable: true,
        width: 200,
        filterable: true,
        filterRenderer: FilterMultiKeyword,
        formatter: DiscontinuedProductCellBackGroundFormatter,
        getRowMetaData: row => row,
      },
      {
        key: 'Description',
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 120,
        filterable: true,
        formatter: DiscontinuedProductCellBackGroundFormatter,
        getRowMetaData: row => row,
      },
      {
        key: 'RefPrice',
        name: <Translate value="unit_price" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: 'PackageType',
        name: <Translate value="pkg_type" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      },
      {
        key: 'PackageSize',
        name: <Translate value="package_size" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: 'MeasureUnit',
        name: <Translate value="mm_unit" />,
        resizable: true,
        sortable: true,
        width: 70,
        filterable: true,
      },
      {
        key: 'ProductGroup_id__Name',
        name: <Translate value="prod_group" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: 'ProductCategory1_id__Name',
        name: <Translate value="category_1" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: 'ProductCategory2_id__Name',
        name: <Translate value="category_2" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      {
        key: 'IsStopSale',
        name: <Translate value="is_stop_sale" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: IsStopSaleFormatter,
      },
      {
        key: 'IsMobile',
        name: <Translate value="is_mobile_sale" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
        formatter: IsStopSaleFormatter,
      },
    ];

    if (isABCFF) {
      columns = [
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          filterRenderer: FilterByStart,
          formatter: DiscontinuedProductCellBackGroundFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'GeneralNum',
          name: <Translate value={(isMyuMyu || isAFG) ? 'index_no' : 'general_no'} />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          filterRenderer: FilterByStart,
          formatter: DiscontinuedProductCellBackGroundFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'RefNum',
          name: (isTN || isWIZ) ? <Translate value="sku" /> : <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          filterRenderer: FilterMultiKeyword,
          formatter: DiscontinuedProductCellBackGroundFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'Name',
          name: <Translate value="item_name" />,
          resizable: true,
          sortable: true,
          width: 200,
          filterable: true,
          filterRenderer: FilterMultiKeyword,
          formatter: DiscontinuedProductCellBackGroundFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
          formatter: DiscontinuedProductCellBackGroundFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'CustomerName',
          name: <Translate value="customer" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        },

        {
          key: 'VendorStyleNum',
          name: <Translate value="vendor_style" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        },
        {
          key: 'TJXStyleNum',
          name: <Translate value="tjx_style" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        },
        {
          key: 'UPC',
          name: <Translate value="upc" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        },
        {
          key: 'Color',
          name: <Translate value="color" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        },
        {
          key: 'Size',
          name: <Translate value="size/ratio" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        },


        {
          key: 'RefPrice',
          name: <Translate value="unit_price" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'MeasureUnit',
          name: <Translate value="mm_unit" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        },
        {
          key: 'ProductGroup_id__Name',
          name: <Translate value="prod_group" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'ProductCategory1_id__Name',
          name: <Translate value="category_1" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'ProductCategory2_id__Name',
          name: <Translate value="category_2" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'IsStopSale',
          name: <Translate value="is_stop_sale" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          formatter: IsStopSaleFormatter,
        },
        {
          key: 'IsMobile',
          name: <Translate value="is_mobile_sale" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          formatter: IsStopSaleFormatter,
        },
      ];
    }

    if (isSW) {
      columns = [
        {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
          filterRenderer: FilterByStart,
          formatter: DiscontinuedProductCellBackGroundFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'GeneralNum',
          name: <Translate value={(isMyuMyu || isAFG) ? 'index_no' : 'general_no'} />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
          filterRenderer: FilterByStart,
          formatter: DiscontinuedProductCellBackGroundFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'RefNum',
          name: (isTN || isWIZ) ? <Translate value="sku" /> : <Translate value="ref_num" />,
          resizable: true,
          sortable: true,
          width: 165,
          filterable: true,
          filterRenderer: FilterMultiKeyword,
          formatter: DiscontinuedProductCellBackGroundFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'Name',
          name: <Translate value="item_name" />,
          resizable: true,
          sortable: true,
          width: 250,
          filterable: true,
          filterRenderer: FilterMultiKeyword,
          formatter: DiscontinuedProductCellBackGroundFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
          formatter: DiscontinuedProductCellBackGroundFormatter,
          getRowMetaData: row => row,
        },
        {
          key: 'RefPrice',
          name: <Translate value="unit_price" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'PackageSize',
          name: <Translate value="package_size" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'MeasureUnit',
          name: <Translate value="mm_unit" />,
          resizable: true,
          sortable: true,
          width: 70,
          filterable: true,
        },
        {
          key: 'ProductGroup_id__Name',
          name: <Translate value="prod_group" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'ProductCategory1_id__Name',
          name: <Translate value="category_1" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'ProductCategory2_id__Name',
          name: <Translate value="category_2" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'Brand',
          name: <Translate value="brand" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'Color',
          name: <Translate value="color" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'Size',
          name: <Translate value="size" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'IsStopSale',
          name: <Translate value="is_stop_sale" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          formatter: IsStopSaleFormatter,
        },
        {
          key: 'IsMobile',
          name: <Translate value="is_mobile_sale" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          formatter: IsStopSaleFormatter,
        },
      ];
    }

    if (isAFG || isMyuMyu || isWecom) {
      const indexGeneralNum = _.findIndex(columns, { key: 'GeneralNum' });
      const generalColumn = {
        key: 'GeneralNumDisplay',
        name: <Translate value={(isMyuMyu || isAFG || isWecom) ? 'index_no' : 'general_no'} />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        // filterRenderer: FilterByStart,
        formatter: DiscontinuedProductCellBackGroundFormatter,
        getRowMetaData: row => row,
      }
      columns.splice(indexGeneralNum, 1, generalColumn);
      if (this.state.rows.length > 0) {
        this.state.rows.map((row) => {
          if (row.GeneralNum) {
            row.GeneralNumDisplay = Number(row.GeneralNum);
          } else {
            row.GeneralNumDisplay = null;
          }
        });
      }
    }

    if (isLO) {
      let refNumIndex = columns.findIndex(column => column.key === 'RefNum');
      if(refNumIndex !== -1) {
        columns[refNumIndex].name = <Translate value="item_num" />
      }
      let itemNameIndex = columns.findIndex(column => column.key === 'Name');
      if(itemNameIndex !== -1) {
        columns[itemNameIndex].name = <Translate value="item_description"/>;
        columns[itemNameIndex].width = 300;
      }
      let descriptionIndex = columns.findIndex(column => column.key === 'Description');
      if(descriptionIndex !== -1) {
        columns.splice(descriptionIndex, 1);
      }
    }

    let reactDataGridOtherProps = {};
    if (isUSPride) {
      reactDataGridOtherProps = {
        getValidFilterValues,
      };
    }

    return (
      <Row>
        <Col xs={12}>
          <div style={{ maxWidth: '99%' }} id="Products-dataGrid1">
            <ReactDataGrid
              ref="testingstuff"
              rowRenderer={
                <RowRenderer
                  onDoubleClick={(data) => {
                    if (checkPermission('change_product')) {
                      this.checkDetail(data);
                    } else {
                      alert(I18n.t('msg_no_permission'));
                    }
                  }}
                />
              }
              rowKey="Product_id"
              ref={g => this.tableGrid = g}
              onGridSort={handleGridSort}
              enableCellSelect={true}
              toolbar={<Toolbar enableFilter={true} />}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowHeight={25}
              headerRowHeight={45}
              minHeight={623}
              enableRowSelect="single"
              onRowUpdated={this.handleRowUpdated}
              onRowSelect={onRowSelect}
              rowSelection={{
                showCheckbox: true,
                onRowsSelected,
                onRowsDeselected,
                selectBy: {
                  isSelectedKey: 'isSelected',
                },
              }}
              {...reactDataGridOtherProps}
            />
          </div>
        </Col>
      </Row>
    );
  }
  
  renderTNProductButton() {
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        onClick={() => { this.refs.importProduct.click(); }}
      >
        <em className="fa fa-upload" /><Translate value="product" />
      </Button>
    )
  }

  renderImportZipcodeButton() {
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        onClick={() => { this.refs.importZipcode.click(); }}
      >
        <em className="fa fa-upload" /><Translate value="import_zipcodes" /> (xlsx)
      </Button>
    )
  }

  renderTNBarcodeButton() {
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        onClick={() => { this.refs.importBarcode.click(); }}
      >
        <em className="fa fa-upload" /><Translate value="barcode" />
      </Button>
    )
  }
  
  renderTNTemplatButton() {
    const templateUrl = `${ROOT_URL}v2/product/import-template?Bearer=${localStorage.getItem("token")}`;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        href={ templateUrl }
      >
        <em className="fa fa-download" /><Translate value="product_template" />
      </Button>
    )
  }

  renderTNBarcodeTemplatButton() {
    const templateUrl = `https://scmteambucket.s3.us-west-1.amazonaws.com/TN_Barcode_Templete.xlsx`;
    // const templateUrl = `${ROOT_URL}v2/product/barcode-template?Bearer=${localStorage.getItem("token")}`;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        href={ templateUrl }
      >
        <em className="fa fa-download" /><Translate value="barcode_template" />
      </Button>
    )
  }
  renderImportProductButton() {
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        onClick={() => {
          document.getElementById("myInputTest").click()
        }}
      >
        <em className="fa fa-upload" /><Translate value="upload_product" />
        <input
          id="myInputTest"
          type="file"
          accept=".xls"
          style={{ display: "none" }}
          onClick={(e) => { e.target.value = null }}
          onChange={(e) => {
            const data = new FormData();
            data.append("file", e.target.files[0]);
            if (e.target.files[0]) {
              axios
                .post(
                  `${ROOT_URL}v1/product/import-jml-product`,
                  data,
                  {
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem(
                        "token"
                      )}`,
                    },
                  }
                )
                .then(
                  (res) => {
                    if (res.status === 200 ) {
                      alert("success")
                    }
                  },
                  (err) => {
                    if (err.data) {
                      alert(err.data);
                    } else {
                      alert("Server issue detected, please contact admin.");
                    }
                  }
                );
            }
          }}
        />
      </Button>
    )
  }

  renderProductTemplatButton() {
    const templateUrl = `https://truckxi-public-bucket.s3.us-west-1.amazonaws.com/storage/jml_product_template.xls`;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        href={ templateUrl }
      >
        <em className="fa fa-download" /><Translate value="product_template" />
      </Button>
    )
  }

  renderTNProductExport = () => {
    const {
      currentCategory,
      currentGroup,
    } = this.state;
    const Bearer = localStorage.getItem('token');
    let params = `?Bearer=${Bearer}&export=csv`;
    if (currentCategory > 0) {
      params += `&ProductCategory1_id=${currentCategory}`
    } else if (currentGroup > 0) {
      params += `&ProductGroup_id=${currentGroup}`
    }

    let url = `${PRODUCTS_URL}search/${params}`;
    
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        href={ url }
      >
        <em className="fa fa-download" /><Translate value="export_produt" />
      </Button>
    )
  }

  renderZipcodeExport = () => {
    const {
      currentCategory,
      currentGroup,
    } = this.state;

    const exportUrl = `${ROOT_URL}v1/product/zipcodes/?Bearer=${localStorage.getItem("token")}`

    return (
      <Button
        bsStyle="success"
        className="print-btn"
        type="button"
        href={ exportUrl }
      >
        <em className="fa fa-download" /><Translate value="export_zipcodes" />
      </Button>
    )
  }

  renderExcel() {
    const {
      currentCategory,
      currentGroup,
    } = this.state;

    let exportUrl = ``;
    let text = "Excel SKU (All)";

    if (currentCategory !== -1) {
      exportUrl = `${ROOT_URL}v1/product/sku_export/?ProductCategory1_id=${currentCategory}&Bearer=${localStorage.getItem("token")}`;
      text = "Excel SKU (Category)"
    } else if (currentGroup !== -1) {
      exportUrl = `${ROOT_URL}v1/product/sku_export/?ProductGroup_id=${currentGroup}&Bearer=${localStorage.getItem("token")}`;
      text = "Excel SKU (Group)"
    } else {
      exportUrl = `${ROOT_URL}v1/product/sku_export/?Bearer=${localStorage.getItem("token")}`;
      text = "Excel SKU (All)"
    }

    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        // onClick={() => { console.log("id",currentGroup,currentCategory) }}
        disabled={false}
      >
        <em className="fa fa-download" />
        &nbsp;{text}
      </Button>
    );
  }

  render() {
    return (
    //---------------
    // Begin HTML
    //---------------
      <ContentWrapper>

        {/* Nav Trail */}
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="general_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="product" />
          </Breadcrumb.Item>
        </Breadcrumb> {/* End Nav Trail */}

        <Grid id="products-inventory-page">
          <Row>
            {/* Inventory Nav */}
            <Col xs={2}>
              <Panel id="category-nav" className="panelStyle" style={{ overflowY: 'scroll', width: '100%' }}>
              {
                    (!isSY || checkPermission('view_group_all')) &&
                <Panel className="panelStyle" >
                  <div style={{ color: APP_COLORS['category-nav'], fontWeight: 'bold', cursor: 'pointer' }} name="group" id="g-1" onClick={this.handleClickGroup.bind(this, null, '-1')}>
                    <Translate value="all" />
                  </div>
                </Panel>
                  }
                {this.renderGroups()}
              </Panel>
            </Col>
            {/* End Inventory Nav */}

            {/* Main Workspace */}
            <Col xs={10}>
              <Panel className="position-relative mb0" id="products">
                <Row>
                  <ButtonToolbar className="table-buttons">
                    <Button
                      bsStyle="primary"
                      type="button"
                      onClick={(event) => { this.clickNew(event); }}
                      disabled={!checkPermission('add_product')}
                    >
                      <em className="fa fa-plus" /><Translate value="create_product" />
                    </Button>
                    <Button
                      bsStyle="warning"
                      type="button"
                      onClick={(event) => { this.setCurrentProduct(event); }}
                      disabled={!this.state.selectedRows || this.state.selectedRows.length !== 1 || !checkPermission('change_product')}
                    >
                      <em className="fa fa-pencil" /><Translate value="edit_product" />
                    </Button>
                    {isJML && this.renderExcel()}
                    {isFBD && this.renderZipcodeExport()}
                    {isFBD && this.renderImportZipcodeButton()}



                    <input
                            type="file"
                            style={{ display: "none" }}
                            onClick={(e)=> {
                              e.target.value = null;
                                }}
                            onChange={(e) => {
                              let URL = `${ROOT_URL}v1/product/zipcodes/`;
                              const formData = new FormData();
                              formData.append("file", e.target.files[0]);
                              if (e.target.files[0]) {
                                axios
                                  .post(
                                    URL,
                                    formData,
                                    {
                                      headers: {
                                        Authorization: `Bearer ${localStorage.getItem(
                                          "token"
                                        )}`,
                                      },
                                    },
                                  )
                                  .then(
                                    (res) => {
                                      alert("Zipcodes uploaded successfully");
                                      // this.fetchSalesOrdersByDetails(
                                      //   this.state.days
                                      // );
                                    },
                                    (err) => {
                                      if (err.data) {
                                        alert(err.data);
                                      } else {
                                        alert("Server issue detected, please contact admin.");
                                      }
                                    }
                                  );
                              }
                            }}
                            ref="importZipcode"
                          />




                    <input
                      type='file'
                      ref='importProduct'
                      onChange={(e) => {
                        const file = e.target.files[0];
                        const formData = new FormData();
                        formData.append('file', file);
                        const succes = () => {
                          alert("Product Import Successful");
                          this.props.resetGroupAndCategory();
                        };
                        productUpload(formData, succes);
                      }}
                      style={{ display: 'none' }}
                    />
                    

                    <input
                            type="file"
                            style={{ display: "none" }}
                            onClick={(e)=> {
                              e.target.value = null;
                                }}
                            onChange={(e) => {
                              let URL = `${ROOT_URL}v2/product/import-barcode`;
                              const formData = new FormData();
                              formData.append("file", e.target.files[0]);
                              if (e.target.files[0]) {
                                axios
                                  .post(
                                    URL,
                                    formData,
                                    {
                                      headers: {
                                        Authorization: `Bearer ${localStorage.getItem(
                                          "token"
                                        )}`,
                                      },
                                    },
                                  )
                                  .then(
                                    (res) => {
                                      alert("barcodes uploaded successfully");
                                      // this.fetchSalesOrdersByDetails(
                                      //   this.state.days
                                      // );
                                    },
                                    (err) => {
                                      if (err.data) {
                                        alert(err.data);
                                      } else {
                                        alert("Server issue detected, please contact admin.");
                                      }
                                    }
                                  );
                              }
                            }}
                            ref="importBarcode"
                          />

                    { isTN && this.renderTNProductButton() }
                    { isTN && this.renderTNTemplatButton() }
                    { isTN && this.renderTNBarcodeButton() }
                    { isTN && this.renderTNBarcodeTemplatButton() }
                    <input
                      style={{ width: '150px', marginLeft:'5px', borderRadius: '5px', padding: '2px', border: '1px solid black' }}
                      type="text"
                      onChange={e => { this.onChangeQuickEntry(e); }}
                      onKeyPress={e => { this.onKeyPressQuickEntry(e); }}
                      value={this.state.quickEntryProductNum}
                      placeholder={I18n.t('product_num_ref_num')}
                    />
                    { isJML && this.renderImportProductButton() }
                    { isJML && this.renderProductTemplatButton() }
                    {
                      this.state.quickEntryShowError &&
                      <span style={{ marginLeft: '3px', color: 'red' }}>
                        <Translate value="product_not_found" />
                        </span>
                    }
                    {/*
                      <Dropzone onDrop={this.onDrop.bind(this)} className="upload-button">
                        <Button bsStyle="primary" >
                          <em className="fa fa-file-text" />
                          <Translate value="upload_import" />
                        </Button>
                      </Dropzone>
                    */}
                  </ButtonToolbar>                  
                </Row>
                <Row>
                  <ButtonToolbar style={{ position: 'relative', marginTop: '30px', marginLeft: '2px' }}>
                    { isTN && this.renderTNProductExport() }
                  </ButtonToolbar>
                </Row>
                {/* Inventory Table */}
                {this.renderTable() }
              </Panel>
            </Col> {/* End Main Workspace */}
          </Row>
        </Grid>
      </ContentWrapper>
      //---------------
      // End HTML
      //---------------
    );
  }
}

export default Products;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/products.jsx